import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { UndergradProgressState } from './state';
import { UndergradDiscipline } from '@/models/undergrad/undergrad-discipline.model';

const getConcatIds = (discipline: UndergradDiscipline) =>
  discipline.submoduleId + discipline.id + discipline.disciplineInstanceId;

const getters: GetterTree<UndergradProgressState, RootState> = {
  isProgressLoading: (state) => state.loading,
  isProgressOutdated: (state) => state.outdated,
  lessonsToContinueStudying: (state) => state.continueStudying,
  getCourseProgress: (state) => (id: string) => state.courses[id] || 0,
  getModuleProgress: (state) => (id: string) => state.modules[id] || 0,
  getDisciplineProgress: (state) => (discipline: UndergradDiscipline) =>
    state.disciplines[getConcatIds(discipline)] || 0,
  getLessonProgress: (state) => (discipline: UndergradDiscipline, lessonId: string) =>
    state.lessons[getConcatIds(discipline) + lessonId] || 0,
  getContentProgress:
    (state) => (discipline: UndergradDiscipline, lessonId: string, contentId: string) =>
      state.contents[getConcatIds(discipline) + lessonId + contentId] || 0,
  getProgressConsumptionMoment:
    (state) => (discipline: UndergradDiscipline, lessonId: string, contentId: string) =>
      state.moments[getConcatIds(discipline) + lessonId + contentId],
};

export default getters;
